export const ANALYTIC_EVENTS = {
  ivStarted: '[IV] Starting the IV process',
  ivTakingPhoto: '[IV] Taking IV photo',
  ivUploadingPhoto: '[IV] Uploading IV photo',
  ivPhotoSent: '[IV] Photo is sent',
  ivPhotoTaken: '[IV] Photo is taken',
  ivResetPhoto: '[IV] Reset photo',
  ivPhotoUploaded: '[IV] Photo is uploaded',
  ivTakingPhotoError: '[IV] Error of taking photo',
  ivUploadingPhotoError: '[IV] Error of uploading photo',
  ivCameraUnavailable: '[IV] Camera unavailable',
  ivRetryingLimitOver: '[IV] Retrying limit is over',
  ivGettingResultsFromOCR: '[IV] Getting results from OCR',
  ivParsingOfDetectedOCRData: '[IV] Parsing of detected OCR data',
  ivGettingResultsFromBiomatch: '[IV] Getting results from Biomatch',
  ivGettingResultsFromBiomatchMatching: '[IV] Getting results from Biomatch matching',
  ivFinishingAllSuccessfully: '[IV] Finishing the whole process successfully',
  ivFinishingFrontSideDocument: '[IV] Document front side verified',
  ivFinishingBackSideDocument: '[IV] Document back side verified',
  ivFinishingDocumentMRZScan: '[IV] Document verified (MRZScan)',
  ivFinishingDocumentFace: '[IV] Document face verified',
  ivFinishingSelfie: '[IV] Selfie verified',
  ivFinishingMatching: '[IV] Document and selfie matched',

  ivDocumentTypeSelected: '[IV] Document type selected',
  ivDocTypeRemappingFailed: '[IV] Document type remapping failed',
  ivLivenessPassed: '[IV] Liveness passed',
  ivLivenessFailed: '[IV] Liveness failed',

  ivFaceDetectionMechanism: '[IV] Face detection mechanism',
  ivSelfieAutoCaptured: '[IV] Selfie auto-captured',
  ivSelfieAutoCaptureFallback: '[IV] Selfie auto-capture fallback',
  ivDocumentAutoCaptured: '[IV] Document auto-captured',
  ivDocumentAutoCaptureFallback: '[IV] Document auto-capture fallback',

  ivPayloadImageSources: '[IV] Payload image sources',

  ivError: '[IV] Error or Failed',
  ivLeaving: '[IV] Leaving views',
  ivSkipping: '[IV] Skipping the process',
};

export const IV_ERROR_CATEGORY = {
  documentNotRecognized: 'document_not_recognized',
  faceNotDetected: 'face_not_detected',
  faceMismatch: 'face_mismatch',
  network: 'network',
  server: 'server',
  unknown: 'unknown',
} as const;

export type IVErrorCategory = (typeof IV_ERROR_CATEGORY)[keyof typeof IV_ERROR_CATEGORY];
